<template>
    <div>
        <app-data-table
            v-if="!!tableData"
            :fields="fields"
            :items="tableData.data"
            :from="tableData.from"
            :to="tableData.to"
            :current-page="tableData.current_page"
            :last-page="tableData.last_page"
            :total="tableData.total"
            :per-page="tableData.per_page"
            :on-change-page="onChangePage"
            @sort="onSort"
        >
            <template slot="actions" slot-scope="{ item }">
                <div v-if="validateDeadLine(item)">
                    <b-btn
                        variant="primary"
                        size="sm"
                        @click="$emit('open-team-evaluation-form', item)"
                        title="Calificar equipo"
                    >
                        <i class="fa fa-sign-in" aria-hidden="true"></i>
                    </b-btn>
                </div>
                <div v-else>
                    <label>Expirada</label>
                </div>
            </template>
            <template
                slot="initial_qualification_period"
                slot-scope="{ item }"
                >{{ item.initial_qualification_period | date }}</template
            >
            <template slot="final_qualification_period" slot-scope="{ item }">{{
                item.final_qualification_period | date
            }}</template>
            <template slot="max_evaluation_date" slot-scope="{ item }">{{
                item.max_evaluation_date | date
            }}</template>
            <template slot="max_actions_plan_date" slot-scope="{ item }">{{
                item.max_actions_plan_date | date
            }}</template>
        </app-data-table>
    </div>
</template>
<script>
export default {
    props: {
        tableData: {
            type: [Array, Object],
            default: '',
        },
        onChangePage: {
            type: Function,
        },
    },
    data: () => ({
        fields,
        length: 0,
    }),
    methods: {
        validateDeadLine(evaluation) {
            const maxEvaluationDate = moment(
                evaluation.max_evaluation_date
            ).format('YYYY-MM-DDTHH:mm')
            const currentDate = moment().format('YYYY-MM-DDTHH:mm')

            if (currentDate <= maxEvaluationDate) {
                return true
            }
        },
        onSort(ctx) {
            this.$emit('sort', ctx)
        },
    },
}
const fields = [
    {
        key: 'name',
        label: 'Nombre',
    },
    {
        key: 'registered_by.name',
        label: 'Usuario creador',
        orderBy: 'registered_by_id',
    },
    {
        key: 'initial_qualification_period',
        label: 'Período inicial',
    },
    {
        key: 'final_qualification_period',
        label: 'Período final',
    },
    {
        key: 'max_evaluation_date',
        label: 'Fecha maxima de calificación',
    },
    {
        key: 'max_actions_plan_date',
        label: 'Fecha maxima a presentar plan',
    },
    {
        key: 'notes',
        label: 'Notas',
    },
    {
        key: 'actions',
        label: 'Acciones',
    },
]
</script>
